import { jsx as o } from "react/jsx-runtime";
import { IconClose as s } from "../IconClose/IconClose.js";
import '../../assets/CloseButton.css';const n = "_closeButton_4z5c7_1", c = {
  closeButton: n
}, r = ({ onClose: t }) => /* @__PURE__ */ o(
  "button",
  {
    className: `${c.closeButton} iOSPWA-closeButton`,
    onClick: t,
    children: /* @__PURE__ */ o(s, {})
  }
);
export {
  r as CloseButton
};
